import { ReactComponent } from './oval-done.svg';
import React from 'react';
import { IIconProps } from './IIconProps';

export const OvalDoneIcon = ({ ...props }: IIconProps) => {
    return <ReactComponent {...props} />
}